export const types = {
    UPDATE_IS_SUPPORT_PWA: "logoutPersist/updateIsSupportPWA"
};

let initialState = {
    isSupportPwa: false,
    promptInstall: null
};

export const logoutPersist = (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_IS_SUPPORT_PWA:
            return {
                ...state,
                isSupportPwa: action.payload.status,
                promptInstall: action.payload.event
            };
        default:
            return state;
    }
};

/* Check browser support PWA  */
export const updateIsSupportPWA = (event, status) => {
    return async (dispatch) => {
        dispatch({
            type: types.UPDATE_IS_SUPPORT_PWA,
            payload: { event: event, status: status }
        });
    };
};